import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AuthService } from '../../services/auth.service';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
    selector: 'app-reset',
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatProgressBarModule,
        ReactiveFormsModule, FormsModule, MatInputModule
    ],
    templateUrl: './reset.component.html',
    styleUrl: './reset.component.scss'
})
export class ResetComponent {
  loading= false;
  resetForm = new FormGroup({
    usuario: new FormControl("", {
      validators: [Validators.required]
    }),
    correo: new FormControl("", {
      validators: [Validators.required, Validators.email]
    })
  })

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<ResetComponent>
  ) {
  }

  onResetPassword(){
    this.loading = true;
    this.authService.resetPassword(this.resetForm.controls.usuario.value||"",this.resetForm.controls.correo.value||"").subscribe({
      next: (response: any) => {
        this.loading = false;
        this.dialogRef.close(1);
      },
      error:(err) => {
        this.loading = false;
        this.dialogRef.close(-1);
      },
    })
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
